<template>
    <u-dialog-color-bg-tile v-model="shows" v-bind="$attrs">
        <template #activator="{ attrs, on }">
            <slot name="activator" v-bind="{ attrs, on }" />
        </template>
        <template v-for="(_, slotName) in $slots" #[slotName]>
            <slot :name="slotName" />
        </template>
    </u-dialog-color-bg-tile>
</template>

<script>
import UDialogColorBgTile from "@/components/publish/styles/dialogs/u-dialog-color-bg-tile.vue";

export default {
    props: {},
    components: {
        UDialogColorBgTile,
    },
    data() {
        return {
            shows: false,
        };
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
